import { render, staticRenderFns } from "./DetailsHeading.vue?vue&type=template&id=5a592804&scoped=true&"
import script from "./DetailsHeading.vue?vue&type=script&lang=js&"
export * from "./DetailsHeading.vue?vue&type=script&lang=js&"
import style0 from "./DetailsHeading.vue?vue&type=style&index=0&id=5a592804&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a592804",
  null
  
)

export default component.exports